import { Drawer, useMediaQuery, useTheme } from '@mui/material';
import { SidebarContent } from './SidebarContent';
import { useState, useEffect } from 'react';

const AdminSidebar = ({ mobileOpen, handleDrawerToggle }) => {
  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const drawerWidth = 260;
  
  const [isHovered, setIsHovered] = useState(false);
  const [isManualCollapse, setIsManualCollapse] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);

  // Reset states when breakpoint changes
  useEffect(() => {
    if (!isMedium) {
      setIsManualCollapse(false);
      setSubmenuOpen(false);
      setIsHovered(false);
    }
  }, [isMedium]);

  const handleDrawerMouseEnter = () => {
    if (isMedium && !isManualCollapse) {
      setIsHovered(true);
    }
  };

  const handleDrawerMouseLeave = () => {
    if (isMedium && !isManualCollapse && !submenuOpen) {
      setIsHovered(false);
    }
  };

  const handleDrawerToggleDesktop = () => {
    if (isMedium) {
      const newState = !isManualCollapse;
      setIsManualCollapse(newState);
      if (newState) {
        setSubmenuOpen(false);
      }
    }
  };

  const handleSubmenuToggle = (isOpen) => {
    setSubmenuOpen(isOpen);
    if (isOpen && isMedium) {
      setIsHovered(true);
    }
  };

  const shouldCollapse = isMedium && !isHovered && !isManualCollapse && !submenuOpen;

  return (
    <>
      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ 
          keepMounted: true,
          BackdropProps: {
            sx: {
              backgroundColor: 'rgba(0,0,0,0.5)'
            }
          }
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          zIndex: theme.zIndex.drawer + 2,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            background: theme.palette.background.paper,
            boxShadow: theme.shadows[16],
            paddingTop: isMobile ? 'max(calc(env(safe-area-inset-top) + 16px), 32px)' : '16px',
          },
        }}
      >
        <SidebarContent 
          handleDrawerToggle={handleDrawerToggle} 
          isCollapsed={false} 
          onSubmenuToggle={handleSubmenuToggle}
        />
      </Drawer>

      {/* Desktop/Tablet Drawer */}
      <Drawer
        variant="permanent"
        onMouseEnter={handleDrawerMouseEnter}
        onMouseLeave={handleDrawerMouseLeave}
        sx={{
          display: { xs: 'none', sm: 'block' },
          '& .MuiDrawer-paper': {
            width: shouldCollapse ? 72 : drawerWidth,
            boxSizing: 'border-box',
            background: theme.palette.background.paper,
            borderRight: 'none',
            transition: theme.transitions.create('width', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            ...(isMedium && (isHovered || submenuOpen) && {
              boxShadow: theme.shadows[16],
              zIndex: theme.zIndex.drawer + 1
            }),
          },
        }}
        open
      >
        <SidebarContent 
          isCollapsed={shouldCollapse} 
          handleDrawerToggle={handleDrawerToggleDesktop}
          onSubmenuToggle={handleSubmenuToggle}
        />
      </Drawer>
    </>
  );
};

export default AdminSidebar;